import { Hidden, Stack } from "@mui/material";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { DataGridPro } from '@mui/x-data-grid-pro';
import { columnClubDetail, columnsByStartupDivestment } from "../../helpers/columns/columnDivestment";
import { TableLayoutWithDetail } from "../../layout/TableLayoutWithDetail";

export const DivestmentClubTable = ({ rows }) => {

    const startupList = rows.map(alias => alias.startupAlias)
    const startupListNoRepeat = startupList.filter((item,index)=>{
        return startupList.indexOf(item) === index;
    })
    const objByStartup = startupListNoRepeat.map(startup => {return ({id: startup, startup, data: rows.filter(investment => investment.startupAlias === startup)})})

    const { t } = useTranslation('global')

    const ViewDetails = useCallback((investment) => {
        return (
            <Stack>
                <DataGridPro
                    density="compact"
                    autoHeight
                    columns={columnClubDetail(t)}
                    rows={investment.data}
                    sx={{ flex: 1 }}
                    hideFooter
                />
            </Stack>
        )
    }, [t])

    return (
        <Hidden mdDown>
            <TableLayoutWithDetail
                rows={objByStartup}
                columns={columnsByStartupDivestment(t)}
                title='divestmentClub'
                detail={ViewDetails}
            />
        </Hidden>
    )
}